import { render } from "./EventCard.vue?vue&type=template&id=6a1fb37b&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=6a1fb37b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a1fb37b"

export default script